// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from './../icon/Icon'
import {Tooltip} from './../tooltip/Tooltip'

export enum ButtonSize {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
    XXL = 'xxl'
}

export enum ButtonTheme {
    Primary = 'primary',
    Secondary = 'secondary',
    Inverted = 'inverted',
    Default = 'default',
    Error = 'error',
    Outline = 'outline',
    OutlineSecondary = 'outline-secondary'
}

@Component({
    name: 'Button',
    components: {
        Icon,
        Tooltip,
    },
    mixins: [
        template,
    ]
})
export class Button extends Vue {

    public get themeClass() {
        if ((this.icon || this.$slots['icon']) && this.$slots.default) {
            return `${this.$appPrefix}-button--${this.theme ? this.theme : 'default'}-with-icon`
        }

        if ((this.icon || this.$slots['icon']) && !this.$slots.default) {
            return `${this.$appPrefix}-button--${this.theme ? this.theme : 'default'}-icon`
        }

        return `${this.$appPrefix}-button--${this.theme ? this.theme : 'default'}`
    }

    public get buttonSizeClass() {
        return `${this.$appPrefix}-button--${this.size}`
    }

    public get iconSizeClass() {
        return `${this.$appPrefix}-button--icon-${this.iconSize}`
    }

    public get iconColorClass() {
        return this.iconColor ? `${this.$appPrefix}-button--icon-color-${this.iconColor}` : ''
    }

    public get iconSubcolorClass() {
        return this.iconSubcolor ? `${this.$appPrefix}-button--icon-subcolor-${this.iconSubcolor}` : ''
    }

    public get arrowRightClass() {

        // !!! Special case for only right arrow icon !!!
        return (this.icon == this.$icons.ARROW_RIGHT && this.$slots['default']) ? `${this.$appPrefix}-button--arrow-right` : ''
    }

    public get inlineClass() {
        return this.inline ? `${this.$appPrefix}-button--inline` : ''
    }

    public get disabledClass() {
        if (!this.disabled){
            return ''
        }

        if ((this.icon || this.$slots['icon']) && this.$slots.default) {
            return `${this.$appPrefix}-button--${this.theme ? this.theme : 'default'}-with-icon--disabled`
        }

        if ((this.icon || this.$slots['icon']) && !this.$slots.default) {
            return `${this.$appPrefix}-button--${this.theme ? this.theme : 'default'}-icon--disabled`
        }

        return `${this.$appPrefix}-button--${this.theme ? this.theme : 'default'}--disabled`
    }

    @Prop()
    public type?: string

    @Prop({default: ButtonTheme.Default})
    public theme!: ButtonTheme

    @Prop()
    public icon?: string
    public defaultIcon?: any = null

    @Prop()
    public iconFile?: string
    public defaultIconFile?: any = null

    @Prop()
    public iconClass?: string

    @Prop({default: 'md'})
    public iconSize?: string

    @Prop()
    public iconColor?: string

    @Prop()
    public iconSubcolor?: string

    @Prop({default: ButtonSize.MD})
    public size?: ButtonSize

    @Prop()
    public disabled?: boolean

    @Prop({default: true})
    public visible?: boolean

    @Prop({default: false})
    public inline?: boolean

    public created () {

    }

    public onClick(event) {
        return !this.disabled && this.$emit('click', event)
    }
}